module.exports = __webpack_public_path__ + "static/media/1.3ea12a9c.png";